module.exports = __webpack_public_path__ + "static/img/ad.2719f01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad.png
// module id = AZjx
// module chunks = 4